export default __webpack_public_path__ + "static/media/grinScopeMiniInfo.f0b66bd3.png";